/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntitySourcelistsOrderBy } from './MonitEntitySourcelistsOrderBy';
import {
    MonitEntitySourcelistsOrderByFromJSON,
    MonitEntitySourcelistsOrderByFromJSONTyped,
    MonitEntitySourcelistsOrderByToJSON,
} from './MonitEntitySourcelistsOrderBy';

/**
 * 
 * @export
 * @interface MonitGetEntitySourcelistsQueries
 */
export interface MonitGetEntitySourcelistsQueries {
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntitySourcelistsQueries
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntitySourcelistsQueries
     */
    page_size?: number;
    /**
     * 
     * @type {MonitEntitySourcelistsOrderBy}
     * @memberof MonitGetEntitySourcelistsQueries
     */
    order_by?: MonitEntitySourcelistsOrderBy;
    /**
     * 
     * @type {boolean}
     * @memberof MonitGetEntitySourcelistsQueries
     */
    desc?: boolean;
}

/**
 * Check if a given object implements the MonitGetEntitySourcelistsQueries interface.
 */
export function instanceOfMonitGetEntitySourcelistsQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntitySourcelistsQueriesFromJSON(json: any): MonitGetEntitySourcelistsQueries {
    return MonitGetEntitySourcelistsQueriesFromJSONTyped(json, false);
}

export function MonitGetEntitySourcelistsQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntitySourcelistsQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'order_by': !exists(json, 'order_by') ? undefined : MonitEntitySourcelistsOrderByFromJSON(json['order_by']),
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function MonitGetEntitySourcelistsQueriesToJSON(value?: MonitGetEntitySourcelistsQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'order_by': MonitEntitySourcelistsOrderByToJSON(value.order_by),
        'desc': value.desc,
    };
}

